import type {
  AppendixStatus,
  ContractAppendixArtifact,
} from '@/entities/contract/api/contract.api';
import { formatDateTime } from '@/shared/lib/dateFormat';

export const APPENDIX_STATUS = {
  PENDING: 'PENDING',
  GENERATING: 'GENERATING',
  READY: 'READY',
  FAILED: 'FAILED',
} as const satisfies Record<string, AppendixStatus>;

export const APPENDIX_STATUS_META: Record<
  AppendixStatus,
  { label: string; badgeClass: string }
> = {
  PENDING: {
    label: '대기',
    badgeClass: 'bg-muted text-muted-foreground',
  },
  GENERATING: {
    label: '생성 중',
    badgeClass: 'bg-ruda-bg-tertiary text-ruda-primary',
  },
  READY: {
    label: '준비 완료',
    badgeClass: 'bg-emerald-50 text-ruda-success',
  },
  FAILED: {
    label: '생성 실패',
    badgeClass: 'bg-red-50 text-ruda-error',
  },
};

export const POLL_INTERVAL_MS = 3000;

export const formatAppendixDateTime = formatDateTime;

export const formatAppendixFileSize = (bytes?: number): string => {
  if (bytes == null || Number.isNaN(Number(bytes))) return '-';
  const size = Number(bytes);
  if (size < 1024) return `${size.toLocaleString()} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(2)} MB`;
};

export const isAppendixArtifactReady = (
  artifact?: ContractAppendixArtifact | null,
): boolean =>
  Boolean(artifact?.ready || artifact?.status === APPENDIX_STATUS.READY);

/** 다음 생성 버전 = max(version) + 1 (레거시 nextVersion) */
export const getNextAppendixVersion = (
  artifacts: ContractAppendixArtifact[],
): number => {
  if (artifacts.length === 0) return 1;
  return Math.max(...artifacts.map((item) => Number(item.version) || 0)) + 1;
};

export const appendixRowKey = (artifact: ContractAppendixArtifact): string =>
  artifact.artifactId ?? `${artifact.refYm}-${artifact.version}`;
